import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GOAL_STATUS } from 'goals-reporting-lib/constants/goals';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIList from 'UIComponents/list/UIList';
import HR from 'UIComponents/elements/HR';
import { Set as ImmutableSet } from 'immutable';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';

const getFilterButtonText = statuses => {
  if (statuses.size === 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `goals-reporting-lib.table.status.${statuses.first()}`
    });
  }

  if (statuses.size === Object.values(GOAL_STATUS).length) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.allStatuses"
    });
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "filters.multipleStatuses",
    options: {
      count: statuses.size
    }
  });
};

const GoalStatusFilter = ({
  onChangeStatuses,
  selectedStatuses
}) => {
  const onSelectAllStatuses = () => {
    onChangeStatuses(ImmutableSet(Object.values(GOAL_STATUS)));
  };

  const onChange = status => {
    return event => {
      const updatedStatuses = event.target.checked ? selectedStatuses.add(status) : selectedStatuses.delete(status);

      if (updatedStatuses.size) {
        onChangeStatuses(updatedStatuses);
      } else {
        onSelectAllStatuses();
      }
    };
  };

  const getOption = status => {
    return /*#__PURE__*/_jsx(UICheckbox, {
      checked: selectedStatuses.has(status),
      onChange: onChange(status),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `goals-reporting-lib.table.status.${status}`
      })
    }, status);
  };

  const entityStatuses = Object.values(GOAL_STATUS);
  const options = entityStatuses.map(getOption);
  const allStatusesSelected = selectedStatuses.size === entityStatuses.length;
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.statusFilterLabel"
    }),
    children: /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "link",
      buttonText: getFilterButtonText(selectedStatuses),
      menuWidth: 250,
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(UICheckbox, {
          checked: allStatusesSelected,
          indeterminate: !allStatusesSelected,
          onChange: onSelectAllStatuses,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "filters.selectAll"
          })
        }), /*#__PURE__*/_jsx(HR, {
          distance: "extra-small"
        }), options]
      })
    })
  });
};

export default GoalStatusFilter;